/**
 * const soundAssets = {
 *   se_bgm: {src:[`${audio_dir}se/bgm${audio_ext}`], loop: true, volume:0.3},
 *   se_clear: {src:[`${audio_dir}se/clear${audio_ext}`]},
 * }
 * 
 * const sound = new AudioPlayer(soundAssets);
 * sound.load()
 * .then(() => {
 *  sound.playOne('se_bgm');  // 単発再生
 *  sound.playSequence(['apple', 'lemon', 'grapes']);   // 連続再生
 * }
 * .catch((err) => {});
 */

import { Howl } from 'howler';


export default class AudioPlayer{

    constructor(files) {
        this.files = files;
        this.sounds = {};
        this.onSoundEnd = null;
        this.onSequenceEnd = null;
        this.onSequenceAllEnd = null;
        this.onSequenceOneStart = null;
        this.onSequenceOneEnd = null;

        this.currentlyPlayingSound = null;
        this.sequenceQueue = [];
        this.sequenceDelay = 0;
        this.lastEvent = null;

        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        // 一時停止から復帰した際に再生させる音を保存
        this.playingSounds = new Set();

        this._init();
    }


    /**
     * 読み込み
     * @returns Promise
     */
    load(){
        const promises = Object.keys(this.files).map(key => {

            return new Promise((resolve, reject) => {
                const sound = new Howl(this.files[key]);
                sound.once('load', ()=>{ resolve(); });
                sound.once('loaderror', ()=>{ reject(); });
                this.sounds[key] = sound;
            });
        });

        return Promise.all(promises);
    }


    /**
     * 単発で再生する
     */
    playOne(key, callback, vol=null){
        if(!this.sounds[key]) return;
        //if(!this.isActiveWindow) return;

        if(vol) this.sounds[key].volume(vol);
        this.sounds[key].play();
        this.sounds[key].once('end', ()=>{
            if(callback) callback(key);
            else if(this.onSoundEnd) this.onSoundEnd(key);
        });
        this.currentlyPlayingSound = this.sounds[key];
    }


    /**
     * 順番に連続で再生する
     */
    playSequence(keys, callback, vol){
        this.sequenceQueue = [...keys];
        this.onSequenceAllEnd = callback;
        this._playNextInSequence(vol);
    }


    /**
     * サウンドを停止する
     */
    stop(key){
        if(!this.sounds[key].playing()) return;
        this.sounds[key].stop();
    }

    stopAll(){

        for(let key in this.sounds){
            if(this.sounds[key].playing()) this.sounds[key].stop();
        }

        // 連続再生の状態をリセット
        this.sequenceQueue = [];
    }


    /**
     * 単音再生終了後のコールバック
     * @param callback 
     */
    setOnSoundEnd(callback){
        this.onSoundEnd = callback;
    }

    
    /**
     * 連続再生終了後のコールバック
     * @param callback 
     */
    setOnSequenceAllEnd(callback){
        this.onSequenceAllEnd = callback;
    }


    /**
     * 連続再生時の個々のサウンド開始時のコールバック
     * @param callback 
     */
    setOnSequenceOneStart(callback, delay){
        this.onSequenceOneStart = callback;
        if(delay !== null) this.sequenceDelay = delay;
    }

    /**
     * 連続再生時の個々のサウンド終了時のコールバック
     * @param callback 
     */
    setOnSequenceOneEnd(callback){
        this.onSequenceOneEnd = callback;
    }


    /**
     * サウンドを破棄する
     */
    destroy(){
        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);

        for(let key in this.sounds){
            this.sounds[key].unload();
        }

        this.sounds = [];
        this.onSoundEnd = null;
        this.onSequenceEnd = null;
        this.onSequenceAllEnd = null;
        this.onSequenceOneStart = null;
        this.onSequenceOneEnd = null;
    }


    _playNextInSequence(vol=null){

        if(this.sequenceQueue.length > 0){
            let key = this.sequenceQueue.shift();
            this.playOne(key, null, vol);

            if(this.onSequenceOneStart){
                this.onSequenceOneStart(key);
            }

            this.sounds[key].once('end', ()=>{
                if(this.onSequenceOneEnd) this.onSequenceOneEnd(key);

                if(this.sequenceDelay){
                    
                    setTimeout(()=>{
                        this._playNextInSequence(vol);
                    }, this.sequenceDelay);
                }
                else{
                    this._playNextInSequence(vol);
                }
            });
        }
        else{
            if(this.onSequenceAllEnd) this.onSequenceAllEnd();
        }
    }


    _init(){
        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    _pause(){
        //this.playingSounds.clear();

        for(let key in this.sounds){
            if(!this.sounds[key]) continue;

            if (this.sounds[key].playing()) {
                this.playingSounds.add(key);
                this.sounds[key].pause();
            }
        }
    }
    

    _resume(){

        for(let key of this.playingSounds){
            if(!this.sounds[key]) continue;

            if(!this.sounds[key].playing()){
                this.sounds[key].play();
            }
        }

        this.playingSounds.clear();
    }
}